import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import _ from 'underscore';

import {changeSetting} from 'common/actions/settings';
import {serviceTypes} from 'common/types/Service';
import {
  getActiveAgency,
  getActiveRides,
  getActiveService,
  getAgencySettings,
  getAvailableServices,
  getUnavailableServices,
} from 'ondemand/selectors';
import {fetchAgenciesIfNeeded} from 'ondemand/actions/agency';
import {fetchAgencySettingsIfNeeded} from 'common/actions/agencySettings';
import {fetchRidesIfNeeded} from 'ondemand/actions/ride';
import {fetchServicesIfNeeded} from 'ondemand/actions/service';
import {popAllAlerts, pushAlert} from 'ondemand/actions/alert';
import ServicePickerModal from 'ondemand/components/ServicePickerModal';


const ondemandServices = (services) => _.where(services, {service_type: serviceTypes.ONDEMAND});

class ServicePicker extends React.Component {
  static displayName = 'ServicePicker';

  static propTypes = {
    agency: PropTypes.object,
    agencySettings: PropTypes.object,
    availableServices: PropTypes.arrayOf(PropTypes.object),
    dispatch: PropTypes.func,
    activeRides: PropTypes.arrayOf(PropTypes.object),
    service: PropTypes.object,
    unavailableServices: PropTypes.arrayOf(PropTypes.object),
  };

  componentDidMount() {
    this.props.dispatch(fetchAgenciesIfNeeded());
    this.props.dispatch(fetchRidesIfNeeded());
    this._fetchServices(this.props.agency);
    if (this.props.agency) {
      this.props.dispatch(fetchAgencySettingsIfNeeded(this.props.agency.agencyId));
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agency !== this.props.agency) {
      this.props.dispatch(fetchAgencySettingsIfNeeded(this.props.agency.agencyId)).then(() =>
        this._fetchServices(this.props.agency)
      );
    }
  }

  _dispatchServiceExceptionInfo(service) {
    if (!service.currentException) return;
    this.props.dispatch(pushAlert({
      title: service.name,
      subtitle: service.currentException.message || this.props.agencySettings.service_message,
      level: service.currentException.removal ? 'error' : 'info',
    }));
  }

  _fetchServices = (agency) => {
    if (agency === null) return;
    this.props.dispatch(fetchServicesIfNeeded(agency.agencyId))
      .then(() => {
        // remove alerts that may have been from previous agencies
        this.props.dispatch(popAllAlerts());
        // candidateServices are ones that we can default to for the user
        const candidateServices = ondemandServices(this.props.availableServices);
        if (this.props.availableServices.length === 1 && candidateServices.length === 1) {
          const service = candidateServices[0];
          this.props.dispatch(changeSetting('serviceId', service.service_id));
          if (service.currentException) {
            this._dispatchServiceExceptionInfo(service);
          }
        } else if (this.props.availableServices.length === 0) {
          if (_.size(this.props.activeRides)) {
            this.props.dispatch(pushAlert({
              title: 'Ride Currently in Progress',
              subtitle: 'You cannot book another ride at the same time',
            }));
          } else {
            const serviceMessage = this.props.agencySettings.service_message;
            this.props.dispatch(pushAlert({
              title: serviceMessage ? '' : 'No Service Currently Available',
              subtitle: serviceMessage || 'Click to see your agency\'s services',
              target: '/agency',
              hideClose: true,
            }));

            _.filter(this.props.unavailableServices, (service) => service.currentException &&
            service.currentException.removal)
            .map((service) => this._dispatchServiceExceptionInfo(service));
          }
        }
      });
  };

  _handleServiceClick = (service) => {
    this.props.dispatch(changeSetting('serviceId', service.service_id));
    if (service.currentException) {
      this._dispatchServiceExceptionInfo(service);
    }
  };

  render() {
    const {
      agency,
      agencySettings,
      availableServices,
      service,
      unavailableServices,
    } = this.props;
    return (
      <ServicePickerModal
        dataId={'service-select-modal-container'}
        serviceMessage={agencySettings.service_message}
        availableServices={availableServices}
        unavailableServices={unavailableServices}
        onServiceClick={this._handleServiceClick}
        open={!!agency && !!_.size(availableServices) && !service}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  agency: getActiveAgency(state),
  agencySettings: getAgencySettings(state),
  availableServices: getAvailableServices(state),
  activeRides: getActiveRides(state),
  service: getActiveService(state),
  unavailableServices: getUnavailableServices(state),
});

export default connect(mapStateToProps)(ServicePicker);



// WEBPACK FOOTER //
// ./src/ondemand/containers/ServicePicker.js